import _regeneratorRuntime from "/Users/janjelschen/apploft/tln/tln_lottonds_backend/deployments/firebase/apploft_cloud_react_modules/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/janjelschen/apploft/tln/tln_lottonds_backend/deployments/firebase/apploft_cloud_react_modules/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

/**
 * http.js
 *
 * Copyright (c) apploft. GmbH
 */
import HTTPError, { getDefaultErrorByStatusCode } from './HTTPError';
var CONTENT_TYPE = 'application/json';

function createHeaders(authorization) {
  var headers = new Headers();
  headers.append('Content-Type', CONTENT_TYPE);
  headers.append('Authorization', authorization);
  return headers;
}

function firstValidationError(context) {
  if (!context) {
    return null;
  }

  var validationErrors = context.validationErrors;

  if (!validationErrors || validationErrors.length < 1) {
    return null;
  }

  if (Array.isArray(validationErrors)) {
    return validationErrors[0];
  } else if (typeof validationErrors === 'string') {
    return validationErrors;
  }

  return null;
}

function createMessage(payload) {
  var error = payload.error;
  var context = error.context,
      message = error.message;
  return firstValidationError(context) || message || 'unsuccessful response';
}

function json(_x) {
  return _json.apply(this, arguments);
}

function _json() {
  _json = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var res, opts, ok, status, url, info;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            res = _ref.res, opts = _ref.opts;
            ok = res.ok, status = res.status, url = res.url;

            if (ok) {
              _context.next = 13;
              break;
            }

            _context.prev = 3;
            _context.next = 6;
            return res.json();

          case 6:
            info = _context.sent;
            _context.next = 12;
            break;

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](3);
            throw getDefaultErrorByStatusCode(res, {
              status: status,
              url: url,
              info: {
                ok: false
              },
              opts: opts
            });

          case 12:
            throw new HTTPError(createMessage(info), {
              status: status,
              url: url,
              info: info,
              opts: opts
            });

          case 13:
            _context.t1 = status;
            _context.next = _context.t1 === 204 ? 16 : 17;
            break;

          case 16:
            return _context.abrupt("return", {
              ok: true
            });

          case 17:
            _context.next = 19;
            return res.json();

          case 19:
            return _context.abrupt("return", _context.sent);

          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3, 9]]);
  }));
  return _json.apply(this, arguments);
}

function request(_x2, _x3) {
  return _request.apply(this, arguments);
}

function _request() {
  _request = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(url, opts) {
    var res;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return fetch(url, opts);

          case 3:
            res = _context2.sent;
            _context2.next = 9;
            break;

          case 6:
            _context2.prev = 6;
            _context2.t0 = _context2["catch"](0);
            throw _context2.t0;

          case 9:
            return _context2.abrupt("return", res);

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 6]]);
  }));
  return _request.apply(this, arguments);
}

function create(_x4, _x5) {
  return _create.apply(this, arguments);
}

function _create() {
  _create = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(method, _ref2) {
    var url, data, authorization, signal, opts, res;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            url = _ref2.url, data = _ref2.data, authorization = _ref2.authorization, signal = _ref2.signal;
            opts = {
              method: method,
              headers: createHeaders(authorization),
              accept: CONTENT_TYPE,
              body: JSON.stringify(data),
              signal: signal
            };
            _context3.next = 4;
            return request(url, opts);

          case 4:
            res = _context3.sent;
            _context3.next = 7;
            return json({
              res: res,
              opts: opts
            });

          case 7:
            return _context3.abrupt("return", _context3.sent);

          case 8:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _create.apply(this, arguments);
}

function post(_x6) {
  return _post.apply(this, arguments);
}

function _post() {
  _post = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref3) {
    var url, data, authorization, signal;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            url = _ref3.url, data = _ref3.data, authorization = _ref3.authorization, signal = _ref3.signal;
            _context4.next = 3;
            return create('POST', {
              url: url,
              data: data,
              authorization: authorization,
              signal: signal
            });

          case 3:
            return _context4.abrupt("return", _context4.sent);

          case 4:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _post.apply(this, arguments);
}

function put(_x7) {
  return _put.apply(this, arguments);
}

function _put() {
  _put = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref4) {
    var url, data, authorization, signal;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            url = _ref4.url, data = _ref4.data, authorization = _ref4.authorization, signal = _ref4.signal;
            _context5.next = 3;
            return create('PUT', {
              url: url,
              data: data,
              authorization: authorization,
              signal: signal
            });

          case 3:
            return _context5.abrupt("return", _context5.sent);

          case 4:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _put.apply(this, arguments);
}

function get(_x8) {
  return _get.apply(this, arguments);
}

function _get() {
  _get = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref5) {
    var url, authorization, signal, opts, res;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            url = _ref5.url, authorization = _ref5.authorization, signal = _ref5.signal;
            opts = {
              method: 'GET',
              headers: createHeaders(authorization),
              accept: CONTENT_TYPE,
              signal: signal
            };
            _context6.next = 4;
            return request(url, opts);

          case 4:
            res = _context6.sent;
            _context6.next = 7;
            return json({
              res: res,
              opts: opts
            });

          case 7:
            return _context6.abrupt("return", _context6.sent);

          case 8:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _get.apply(this, arguments);
}

function del(_x9) {
  return _del.apply(this, arguments);
}

function _del() {
  _del = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(_ref6) {
    var url, authorization, signal, opts, res;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            url = _ref6.url, authorization = _ref6.authorization, signal = _ref6.signal;
            opts = {
              method: 'DELETE',
              headers: createHeaders(authorization),
              accept: CONTENT_TYPE,
              signal: signal
            };
            _context7.next = 4;
            return request(url, opts);

          case 4:
            res = _context7.sent;
            _context7.next = 7;
            return json({
              res: res,
              opts: opts
            });

          case 7:
            return _context7.abrupt("return", _context7.sent);

          case 8:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _del.apply(this, arguments);
}

export { post, get, put, del };